import { useState, useEffect } from 'react';
import * as S from "./styles";
import { useToken } from '../../Components/TokenContext';
import { PremioItens } from '../../Components/PremioItens';

import promoLogo from '../../assets/img/promoLogo.png';

function Premio() {
    const { tokenData, solicitarPremio } = useToken();
    const [premios, setPremios] = useState([]);
    const [error, setError] = useState('');
    const baseUrl = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(true);
    const accessToken = localStorage.getItem('access_token');

    const fetchMyPremios = async () => {
        try {
            const response = await fetch(`${baseUrl}/meus/premios`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                setLoading(false);
                setError('Nenhm prêmio foi encontrado em sua lista.')
                return;
            }

            const data = await response.json();
            console.log(data)
            setPremios(data.premios);

        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMyPremios();
    }, []);

    return (
        <S.Container>
            <section className="bg-primary overflow-hidden">
                <div className="container max-w-large">
                    <img src={promoLogo} alt="Logo da promoção" className="mx-auto w-[160px] sm:w-[200px] 2xl:w-[250px] pt-24 sm:pt-40 2xl:pt-44 pb-8 sm:pb-12 brightness-0 invert pointer-events-none" />
                    
                    {tokenData.tipo == 'participante' && (
                        <div>
                            <h2 className="font-secondary-xt text-4xl 2xl:text-[45px] text-tertiary text-center font-semibold mb-6">Olá, {tokenData.nome}</h2>
                            <h4 className="bg-tertiary w-3/4 max-w-[400px] mx-auto text-primary text-2xl 2xl:text-[29px] text-center rounded-2xl p-2 pb-3">Você possui <span>{tokenData.pontosAtuais} {tokenData.pontosAtuais ? 'pontos' : 'ponto'}</span></h4>
                        </div>
                    )}
                </div>

                <div className="bg-tertiary py-9 mt-10">
                    <div className="container max-w-large">
                    {!solicitarPremio ? (
                        <>
                            <h2 className="font-secondary-xt text-4xl 2xl:text-[45px] text-primary text-center font-semibold mb-6">Meus prêmios</h2>
                            <p className="text-lg text-primary text-center">
                                Acompanhe o status dos seus prêmios com o rastreamento e<br className="max-md:hidden" /> controle o histórico dos pontos que você já gastou.
                            </p>
                        </>
                    ) : (
                        <>
                            <h2 className="font-secondary-xt text-4xl 2xl:text-[45px] text-primary text-center font-semibold mb-2">Atenção!</h2>
                            <p className="text-lg text-primary text-center">
                                Os prêmios só estarão disponíveis para resgate após o término da promoção.
                            </p>
                        </>
                    )}
                        {tokenData.tipo == 'participante' && !solicitarPremio && (
                            <>
                                {loading ? (
                                    <div className={`flex items-center justify-center transition-opacity duration-300`}>
                                        <div className="mt-12 h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
                                    </div>
                                ) : (
                                    premios && premios.length > 0 && (
                                        <div className="my-10">
                                            {premios.map((item, k) => (
                                                <div className="mt-5">
                                                    <PremioItens data={item} key={k} />
                                                </div>
                                            ))}
                                        </div>
                                    )
                                )}
                                {error && (
                                    <p>{error}</p>
                                )}

                                <p className="mt-4 text-xl text-primary text-center">Total de pontos gastos: <strong>{tokenData.pontosGastos} {tokenData.pontosGastos ? 'pts' : 'pt'}</strong></p>
                            </>
                        )}
                    </div>
                </div>
            </section>
        </S.Container>
    );
}

export default Premio;